/*
 * Digital Purchase Order
 *
 * Copyright (c) 2025 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow

function hex2Rgb(color: string): ?Object {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);

    if (!result) {
        return null;
    }

    return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
}
function luminance(color: string): number {
    let rgbColor = hex2Rgb(color);

    if (!rgbColor) {
        return 0;
    }

    let r = rgbColor.r, g = rgbColor.g, b = rgbColor.b;
    let a = [r, g, b].map(function(v) {
        v /= 255;
        return (v <= 0.03928) ?
            v / 12.92 :
            Math.pow(((v + 0.055) / 1.055), 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

export class ColorContrastTools {
    static contrastRatio(color1: string, color2: string) {
        let luminance1 = luminance(color1);
        let luminance2 = luminance(color2);

        let brighter = Math.max(luminance1, luminance2);
        let darker = Math.min(luminance1, luminance2);
        return (brighter+0.05) / (darker + 0.05);       // for formula see: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    }

    static selectContrastColor(baseColor: string, contrastColor1: string, contrastColor2: string): string {
        let contrast1 = this.contrastRatio(baseColor, contrastColor1);
        let contrast2 = this.contrastRatio(baseColor, contrastColor2);

        return (contrast1 >= contrast2) ? contrastColor1 : contrastColor2;
    }

    static getContrastText(color: string): string {
        return this.selectContrastColor(color, '#ffffff', '#000000');
    }

    static improveContrast(color: string, background: string): string {
        let contrast = this.contrastRatio(color, background);
        if (contrast > 4.5) {
            // considered to be an adequate contrast
            return color;
        }


    }
}